"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tournaments = void 0;
var Tournaments_1 = require("./Tournaments");
Object.defineProperty(exports, "Tournaments", { enumerable: true, get: function () { return __importDefault(Tournaments_1).default; } });
